import React from "react";
import Home from "../components/Home";

const LandingPage = () => {
  return <Home />;
};

export default LandingPage;
